import axios from './index.js'
import { cleanParams } from '@/filters'
// 获取公司列表
export const getCompanyData = (params) => {
  return axios.get('/welldbCombine/company', {
    params: {
      ...params
    }
  })
}

export const getCompanyByPage = (params) => {
  return axios.get('/welldbCombine/company', {
    params: cleanParams({ ...params })
  })
}

export const addCompany = (params) => {
  delete params.id
  return axios.post('/welldbCombine/company', {
    moveToQuery: true,
    params: { ...params }
  })
}

export const updateCompany = (params) => {
  return axios.put('/welldbCombine/company', {
    moveToQuery: true,
    params: params
  })
}

export const deleteCompany = (id) => {
  return axios.delete('/welldbCombine/company', {
    params: {
      id: id
    }
  })
}

export const getCompanyMember = (params) => {
  return axios.get('/welldbCombine/companyMember', {
    params: params
  })
}
export const addCompanyMember = (params) => {
  return axios.post('/welldbCombine/companyMember', {
    moveToQuery: true,
    params: params
  })
}

export const updateCompanyMember = (params) => {
  return axios.put('/welldbCombine/companyMember', {
    moveToQuery: true,
    params: params
  })
}

export const deleteCompanyMember = (id) => {
  return axios.delete('/welldbCombine/companyMember', {
    params: {
      id: id
    }
  })
}
